import { render, staticRenderFns } from "./bin-count-detail.vue?vue&type=template&id=048c49db&scoped=true&"
import script from "./js/bin-count-detail.js?vue&type=script&lang=js&"
export * from "./js/bin-count-detail.js?vue&type=script&lang=js&"
import style0 from "./bin-count-detail.vue?vue&type=style&index=0&id=048c49db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048c49db",
  null
  
)

export default component.exports